module.exports = __webpack_public_path__ + "static/banner-texture-60da84bbd7f499a8d94e58482f64a778.png";